import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import configService from './service';

export const useConfig = () => {
  return useService(configService, (state) => state);
};

export const useConfigWithKeys = getUseServiceWithSubscriptionKeys(configService);

export { configService };
